import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Section from "../../common/section";
import FileUpload from "../../common/fileUpload";
import dayjs from "dayjs";
import * as GlobalConstants from "../../../constants/GlobalConstants";

export const EmailSettingsForm = ({
  record,
  uploading,
  progress,
  onHeaderUpload,
  headerFileName,
  onFooterUpload,
  footerFileName,
  disabled,
  uploadDetails,
  onHeaderClear,
  onFooterClear,
}) => {
  const intl = useIntl();

  return (
    <Section title="email_settings">
      <div className="flex flex-column gap-2">
        <div className="grid">
          <div className="col-12">
            <FileUpload
              imageStyleProps={{
                width: "50%",
              }}
              name="emailHeader"
              label="email_header"
              fileType={GlobalConstants.IMAGE_UPLOAD_FILE_TYPES}
              isImage
              infoMessages={[
                intl.formatMessage({
                  id: `upload_type_info_image`,
                }),
                intl.formatMessage(
                  {
                    id: `upload_file_dimensions`,
                  },
                  {
                    width: 600,
                    height: 100,
                  }
                ),
              ]}
              fileUrl={
                (record?.banners?.emailHeader &&
                  `${new URL(
                    record?.banners?.emailHeader,
                    process.env.REACT_APP_URL
                  ).toString()}?v=${dayjs().unix()}`) ||
                null
              }
              uploading={uploading?.[headerFileName]}
              progress={progress?.[headerFileName] || 0}
              onUpload={onHeaderUpload}
              readOnly={disabled}
              uploadDetails={uploadDetails?.[headerFileName]}
              onClear={onHeaderClear}
            />
          </div>
          <div className="col-12">
            <FileUpload
              imageStyleProps={{
                width: "50%",
              }}
              name="emailFooter"
              label="email_footer"
              fileType={GlobalConstants.IMAGE_UPLOAD_FILE_TYPES}
              isImage
              infoMessages={[
                intl.formatMessage({
                  id: `upload_type_info_image`,
                }),
                intl.formatMessage(
                  {
                    id: `upload_file_dimensions`,
                  },
                  {
                    width: 600,
                    height: 50,
                  }
                ),
              ]}
              fileUrl={
                (record?.banners?.emailFooter &&
                  `${new URL(
                    record?.banners?.emailFooter,
                    process.env.REACT_APP_URL
                  ).toString()}?v=${dayjs().unix()}`) ||
                null
              }
              uploading={uploading?.[footerFileName]}
              progress={progress?.[footerFileName] || 0}
              onUpload={onFooterUpload}
              readOnly={disabled}
              uploadDetails={uploadDetails?.[footerFileName]}
              onClear={onFooterClear}
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  uploadDetails: state.uploads?.details,
  uploading: state.uploads?.uploading,
  progress: state.uploads?.progress,
});

export default connect(mapStateToProps)(EmailSettingsForm);
